// Handles communication with the backend AI chat endpoint,
// which routes requests through OpenRouter using free models only.

export const callChatAPI = async (prompt, systemInstruction) => {
    // Backend endpoint. Override with REACT_APP_API_URL in .env for production.
    const backendApiUrl = process.env.REACT_APP_API_URL || '/api/chat';

    try {
        const response = await fetch(backendApiUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ prompt, systemInstruction })
        });

        if (!response.ok) {
            let errorDetail = "";
            try {
                const errJson = await response.json();
                errorDetail = errJson?.error || "";
            } catch {
                errorDetail = await response.text().catch(() => "");
            }
            console.error(`Backend Server Error (${response.status}):`, errorDetail);

            if (response.status === 429) {
                return "The AI assistant is temporarily busy due to high usage. Please try again in a few moments. 🙏";
            }
            if (response.status === 402) {
                return "The AI service is unavailable right now (quota issue). Please try again later.";
            }
            if (response.status === 503) {
                return "No AI models are available at the moment. Please try again in a few seconds.";
            }

            return "Sorry, there was an error communicating with the server. Please try again later.";
        }

        const result = await response.json();
        const candidate = result.candidates?.[0];

        if (candidate && candidate.content?.parts?.[0]?.text) {
            return candidate.content.parts[0].text;
        } else {
            console.error("Unexpected response structure from backend:", result);
            return "Sorry, I received an unexpected response from the AI.";
        }
    } catch (error) {
        console.error('Error calling backend AI endpoint:', error);
        return "Sorry, I couldn't connect to the server. Please check your connection and try again.";
    }
};
